mutation StopCameraControl($camControlId: ID!) {
  camControl: StreamToolsStopCameraControl(camControlId: $camControlId) {
    camControlId
    status
    startedAt
    stoppedAt
    version
    currentCommandIndex
    streak
  }
}
